import 'react';
import { CurvedContainer, JamImage } from '@lendi-jam/atoms';
import Grid from '@lendi-ui/grid';
import { Link, Heading, Body } from '@lendi-ui/typography';
import _taggedTemplateLiteral from '@babel/runtime/helpers/esm/taggedTemplateLiteral';
import { gte } from '@lendi-ui/breakpoint';
import { my, mx, mt, pb } from '@lendi-ui/spacing';
import styled, { css } from 'styled-components';
import { jsx, Fragment, jsxs } from 'react/jsx-runtime';
import _objectSpread from '@babel/runtime/helpers/esm/objectSpread2';
import { embedMarketingTrackingIntoURL } from '@lendi-jam/jam-link';
import { handleButtonTrackingEvent } from '@lendi-jam/tracking';
import { Button } from '@lendi-ui/button';
import { bg, color } from '@lendi-ui/color';
import Container from '@lendi-ui/container';

var _templateObject$2, _templateObject2$2, _templateObject3$2, _templateObject4$1, _templateObject5$1, _templateObject6$1, _templateObject7$1;
var BreadcrumbList = styled.ul(_templateObject$2 || (_templateObject$2 = _taggedTemplateLiteral(["\n  display: inline-block;\n  list-style: none;\n  padding: 0;\n  ", "\n"])), function (_ref) {
  var hasItems = _ref.hasItems,
    isContentHero = _ref.isContentHero;
  if (isContentHero) {
    return css(_templateObject2$2 || (_templateObject2$2 = _taggedTemplateLiteral(["\n        ", "\n      "])), my('xl'));
  }
  return css(_templateObject3$2 || (_templateObject3$2 = _taggedTemplateLiteral(["\n      ", "\n\n      ", "\n    "])), my(hasItems ? 'md' : 'lg'), gte('lg')(_templateObject4$1 || (_templateObject4$1 = _taggedTemplateLiteral(["\n        ", "\n      "])), my(hasItems ? 'lg' : 'xl')));
});
var BreadcrumbListItem = styled.li(_templateObject5$1 || (_templateObject5$1 = _taggedTemplateLiteral(["\n  display: inline-block;\n"])));
var BreadcrumbLink = styled(Link)(_templateObject6$1 || (_templateObject6$1 = _taggedTemplateLiteral(["\n  text-decoration: initial;\n"])));
var BreadcrumbHeading = styled(Heading)(_templateObject7$1 || (_templateObject7$1 = _taggedTemplateLiteral(["\n  display: inline-block;\n  font-weight: ", ";\n  ", "\n"])), function (_ref2) {
  var isbold = _ref2.isbold;
  return isbold ? '700' : '400';
}, mx('xxxs'));

var Breadcrumbs = function Breadcrumbs(_ref) {
  var isContentHero = _ref.isContentHero,
    items = _ref.items,
    variant = _ref.variant;
  var parentLinkColor = variant === 'blue' ? 'primary.500' : 'secondary.500';
  var currentLinkColor = variant === 'blue' ? 'shade.0' : 'shade.700';
  return /*#__PURE__*/jsx(Fragment, {
    children: /*#__PURE__*/jsx(BreadcrumbList, {
      hasItems: !!items,
      isContentHero: isContentHero,
      children: items && items.map(function (item, index) {
        return /*#__PURE__*/jsxs(BreadcrumbListItem, {
          children: [index < items.length - 1 ? /*#__PURE__*/jsx(BreadcrumbLink, {
            href: item.url,
            children: /*#__PURE__*/jsx(BreadcrumbHeading, {
              size: "xxs",
              color: parentLinkColor,
              isbold: true,
              children: item.name
            })
          }) : /*#__PURE__*/jsx(BreadcrumbHeading, {
            size: "xxs",
            color: currentLinkColor,
            children: item.name
          }), index < items.length - 1 && /*#__PURE__*/jsx(BreadcrumbHeading, {
            size: "xxs",
            color: parentLinkColor,
            children: "/"
          })]
        }, "breadcrumb-".concat(index));
      })
    })
  });
};

var _templateObject$1, _templateObject2$1, _templateObject3$1;
var ButtonGrid = styled(Grid)(_templateObject$1 || (_templateObject$1 = _taggedTemplateLiteral(["\n  ", "\n"])), function (_ref) {
  var hasButtons = _ref.hasButtons;
  return mt(hasButtons ? 'xs' : 'nil');
});
var ButtonContainer = styled.div(_templateObject2$1 || (_templateObject2$1 = _taggedTemplateLiteral(["\n  display: inline-block;\n  width: 100%;\n  ", "\n  ", "\n"])), mt('xs'), gte('sm')(_templateObject3$1 || (_templateObject3$1 = _taggedTemplateLiteral(["\n    width: initial;\n  "]))));

var Buttons = function Buttons(_ref) {
  var primaryButton = _ref.primaryButton,
    secondaryButton = _ref.secondaryButton;
  return /*#__PURE__*/jsxs(ButtonGrid, {
    hasButtons: primaryButton || secondaryButton,
    gutter: "xs",
    wrap: true,
    children: [primaryButton && primaryButton.text && /*#__PURE__*/jsx(ButtonContainer, {
      children: /*#__PURE__*/jsx(Button, {
        onClick: function onClick() {
          handleButtonTrackingEvent(_objectSpread(_objectSpread({}, primaryButton), {}, {
            variant: primaryButton.variant
          }));
        },
        size: "md",
        variant: "primary",
        isFullWidth: true,
        href: embedMarketingTrackingIntoURL((primaryButton === null || primaryButton === void 0 ? void 0 : primaryButton.url) || ''),
        children: primaryButton.text
      })
    }), secondaryButton && secondaryButton.text && /*#__PURE__*/jsx(ButtonContainer, {
      children: /*#__PURE__*/jsx(Button, {
        onClick: function onClick() {
          handleButtonTrackingEvent(_objectSpread(_objectSpread({}, secondaryButton), {}, {
            variant: secondaryButton.variant
          }));
        },
        size: "md",
        variant: "secondary",
        isFullWidth: true,
        href: embedMarketingTrackingIntoURL((secondaryButton === null || secondaryButton === void 0 ? void 0 : secondaryButton.url) || ''),
        children: secondaryButton.text
      })
    })]
  });
};
var Buttons$1 = Buttons;

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject10;
var imageHeight = function imageHeight() {
  return "\n  @media (min-width: 0) {\n    height: 10rem;\n  }\n\n  @media (min-width: 36rem) {\n    height: 15rem;\n  }\n\n  @media (min-width: 48rem) {\n    height: 25rem;\n  }      \n";
};
var ImageGridUnit = styled(Grid.Unit)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  ", ";\n  padding-left: 0;\n  order: -1;\n\n  ", ";\n"])), imageHeight(), gte('lg')(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    order: 3;\n  "]))));
var ImageContainer = styled.div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  position: absolute;\n  width: 100%;\n  left: 0;\n  ", ";\n\n  ", "\n"])), imageHeight(), gte('lg')(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n    left: initial;\n    max-width: 53.125rem;\n    width: 50vw;\n  "]))));
var GenericHeroContainer = styled(Container)(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  padding-top: 88px;\n  ", "\n"])), function (_ref) {
  var hasBreadcrumbs = _ref.hasBreadcrumbs,
    isContentHero = _ref.isContentHero;
  return !isContentHero && hasBreadcrumbs ? 'padding-bottom: 88px;' : pb('xxxl');
});
var GenericHeroBackground = styled.div(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n  ", ";\n"])), function (_ref2) {
  var variant = _ref2.variant;
  switch (variant) {
    case 'blue':
      return css(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n          background-color: #003046;\n          color: ", ";\n        "])), color('shade.0'));
    case 'mint':
      return css(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n          ", ";\n          color: ", ";\n        "])), bg('primary.50'), color('shade.800'));
    case 'grey':
      return css(_templateObject9 || (_templateObject9 = _taggedTemplateLiteral(["\n          ", "\n          color: ", ";\n        "])), bg('shade.50'), color('shade.800'));
    default:
      return;
  }
});
var ContentSpacer = styled.div(_templateObject10 || (_templateObject10 = _taggedTemplateLiteral(["\n  ", "\n"])), function (_ref3) {
  var hideBreadcrumbs = _ref3.hideBreadcrumbs;
  return hideBreadcrumbs && mt('xxxl');
});

var GenericHeroImage = function GenericHeroImage(_ref) {
  var _ref$alt = _ref.alt,
    alt = _ref$alt === void 0 ? '' : _ref$alt,
    breadcrumbs = _ref.breadcrumbs,
    _ref$hideBreadcrumbs = _ref.hideBreadcrumbs,
    hideBreadcrumbs = _ref$hideBreadcrumbs === void 0 ? false : _ref$hideBreadcrumbs,
    imageSharp = _ref.imageSharp,
    isFullWidth = _ref.isFullWidth,
    primaryButton = _ref.primaryButton,
    secondaryButton = _ref.secondaryButton,
    subtitle = _ref.subtitle,
    title = _ref.title,
    variant = _ref.variant;
  return /*#__PURE__*/jsx(CurvedContainer, {
    direction: "right",
    radius: "90px",
    children: /*#__PURE__*/jsx(GenericHeroBackground, {
      variant: variant,
      children: /*#__PURE__*/jsx(GenericHeroContainer, {
        hasBreadcrumbs: !!breadcrumbs,
        isContentHero: !imageSharp,
        children: /*#__PURE__*/jsxs(Grid, {
          valign: "center",
          children: [!hideBreadcrumbs && /*#__PURE__*/jsx(Grid.Unit, {
            offset: isFullWidth ? 0 : !imageSharp ? {
              xl: 1 / 12,
              lg: 1 / 12
            } : 0,
            size: isFullWidth || imageSharp ? 1 : {
              xl: 5 / 6,
              lg: 5 / 6
            },
            children: /*#__PURE__*/jsx(Breadcrumbs, {
              items: breadcrumbs,
              variant: variant,
              isContentHero: !imageSharp
            })
          }), /*#__PURE__*/jsxs(Grid.Unit, {
            offset: isFullWidth ? 0 : !imageSharp ? {
              xl: 1 / 12,
              lg: 1 / 12
            } : 0,
            size: isFullWidth ? 1 : imageSharp ? {
              xs: 1,
              sm: 5 / 6,
              md: 4 / 6,
              lg: 4 / 12,
              xl: 5 / 12
            } : 5 / 6,
            children: [hideBreadcrumbs && /*#__PURE__*/jsx(ContentSpacer, {
              hideBreadcrumbs: hideBreadcrumbs
            }), title && /*#__PURE__*/jsx(Heading, {
              size: "xl",
              children: title
            }), subtitle && /*#__PURE__*/jsx(Body, {
              mt: "md",
              size: "lg",
              children: subtitle
            }), /*#__PURE__*/jsx(Buttons$1, {
              primaryButton: primaryButton,
              secondaryButton: secondaryButton
            })]
          }), imageSharp && /*#__PURE__*/jsx(ImageGridUnit, {
            size: {
              xs: 1,
              lg: 1 / 2
            },
            offset: {
              xs: 0,
              lg: 2 / 12,
              xl: 1 / 12
            },
            "data-testid": "GenericeHeroImage-image",
            children: /*#__PURE__*/jsx(ImageContainer, {
              children: /*#__PURE__*/jsx(JamImage, {
                alt: alt,
                placeholder: imageSharp === null || imageSharp === void 0 ? void 0 : imageSharp.base64,
                sizes: imageSharp === null || imageSharp === void 0 ? void 0 : imageSharp.sizes,
                src: imageSharp === null || imageSharp === void 0 ? void 0 : imageSharp.src,
                srcSet: imageSharp === null || imageSharp === void 0 ? void 0 : imageSharp.srcSet
              })
            })
          })]
        })
      })
    })
  });
};

export { Breadcrumbs, GenericHeroImage };
